import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { CopyToClipboard } from '@ui';
import { BaseCurriServiceGroundSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useLegFormContext } from '@lp/features/RoutePlanner/components/RouteLegForm/context/LegFormContext';

export const DeviceDeliveryInputs = () => {
  const { isOptionalDataEdit } = useLegFormContext();
  const { control } = useFormContext<BaseCurriServiceGroundSchemaValues>();

  return (
    <div className="w-full">
      <Controller
        name="trackingNumber"
        control={control}
        render={({ field, fieldState: { invalid } }) => (
          <Input
            aria-label="Tracking Link"
            label="Tracking Link"
            placeholder="Tracking Link"
            isInvalid={invalid}
            isDisabled={!isOptionalDataEdit}
            endContent={<CopyToClipboard text={field.value || ''} />}
            {...field}
          />
        )}
      />
    </div>
  );
};
